// extracted by mini-css-extract-plugin
module.exports = {"headerTitle":"RightholderBooksView__headerTitle","count":"RightholderBooksView__count"};